import { render, staticRenderFns } from "./TrafficPerMonth.vue?vue&type=template&id=380cc773&"
import script from "./TrafficPerMonth.vue?vue&type=script&lang=js&"
export * from "./TrafficPerMonth.vue?vue&type=script&lang=js&"
import style0 from "./TrafficPerMonth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports